<script lang="ts" setup>
import { ref } from '#imports';
import { domToBlob } from 'modern-screenshot';
import icon from '@core/assets/image/im/icon-capture.svg';
import ActionBtn from './ActionBtn.vue';

const props = defineProps<{ sendImage?: (file: File) => void }>();
const loading = ref(false);
function handleScreenshot() {
  loading.value = true;
  domToBlob(document.body, {
    type: 'image/png',
    width: window.innerWidth,
    height: window.innerHeight,
    features: { restoreScrollPosition: true },
    filter(el) {
      if (el.nodeType === Node.ELEMENT_NODE) {
        const excludeClass = ['im-chat-box'];
        return !excludeClass.some((cls) =>
          (el as HTMLElement).classList.contains(cls),
        );
      }
      return true;
    },
  })
    .then((blob) => {
      props.sendImage?.(
        new File([blob], 'screenshot.png', { type: 'image/png' }),
      );
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      loading.value = false;
    });
}
</script>

<template>
  <ActionBtn
    :icon="icon"
    :text="'截屏'"
    :loading="loading ? { delay: 300 } : false"
    @click="handleScreenshot"
  />
</template>
